import SignUp from '@/views/registration/SignUp.vue';

import EmailVerification from '@/views/spFreelancerRegistration/EmailVerification.vue';
import SPFreelancerClientInfo from '@/views/spFreelancerRegistration/SPFreelancerClientInfo.vue';
import CompanyServices from '@/views/spFreelancerRegistration/CompanyServices.vue';
import CompanyCertification from '@/views/spFreelancerRegistration/CompanyCertification.vue';

import { spFreelancerRegistrationGuard, spCompanyRegistrationGuard } from '@/router/guards';

import { views } from '@/router/constants';
import SPFreelancerRegistrationLayout from '@/views/layouts/SPFreelancerRegistrationLayout.vue';
import SPFreelancerRegistrationFinished from '@/views/spFreelancerRegistration/SPFreelancerRegistrationFinished.vue';
import SPCompanyRegistrationLayout from '@/views/layouts/SPCompanyRegistrationLayout.vue';
import SPCompanyInfo from '@/views/spCompanyRegistration/SPCompanyInfo.vue';
import SPCompanyServices from '@/views/spCompanyRegistration/SPCompanyServices.vue';
import SPCompanyCertifications from '@/views/spCompanyRegistration/SPCompanyCertifications.vue';
import SPCompanyEmailVerification from '@/views/spCompanyRegistration/SPCompanyEmailVerification.vue';
import SPCompanyRegistrationFinished from '@/views/spCompanyRegistration/SPCompanyRegistrationFinished.vue';

export default [
  {
    path: '/sign-up',
    component: SignUp,
    name: views.SIGN_UP,
    meta: {
      allowedForUnauthorizedUsers: true,
    },
  },
  {
    path: '/sign-up-freelancer',
    component: SPFreelancerRegistrationLayout,
    beforeEnter: spFreelancerRegistrationGuard,

    children: [
      {
        path: 'email-verification',
        component: EmailVerification,
        name: views.EMAIL_VERIFICATION,
        meta: {
          fullScreen: true,
          allowedForUnauthorizedUsers: true,
        },
      },
      {
        path: 'client-info-freelancer',
        component: SPFreelancerClientInfo,
        name: views.SP_FREELANCER_CLIENT_INFO,
        meta: {
          fullScreen: true,
          allowedForUnauthorizedUsers: true,
        },
      },
      {
        path: 'company-services',
        component: CompanyServices,
        name: views.COMPANY_SERVICES,
        meta: {
          fullScreen: true,
          allowedForUnauthorizedUsers: true,
        },
      },
      {
        path: 'company-certifications',
        component: CompanyCertification,
        name: views.COMPANY_CERTIFICATION,
        meta: {
          fullScreen: true,
          allowedForUnauthorizedUsers: true,
        },
      },
      {
        path: 'finish',
        component: SPFreelancerRegistrationFinished,
        name: views.SP_FREELANCER_REGISTRATION_FINISHED,
        meta: {
          fullScreen: true,
          allowedForUnauthorizedUsers: true,
        },
      },
    ],
  },
  {
    path: '/sign-up-service-provider',
    component: SPCompanyRegistrationLayout,
    beforeEnter: spCompanyRegistrationGuard,

    children: [
      {
        path: 'company-info',
        component: SPCompanyInfo,
        name: views.COMPANY_INFO,
        meta: {
          fullScreen: true,
          allowedForUnauthorizedUsers: true,
        },
      },
      {
        path: 'company-services',
        component: SPCompanyServices,
        name: views.COMPANY_SERVICES_SP,
        meta: {
          fullScreen: true,
          allowedForUnauthorizedUsers: true,
        },
      },
      {
        path: 'company-certifications',
        component: SPCompanyCertifications,
        name: views.COMPANY_CERTIFICATIONS_SP,
        meta: {
          fullScreen: true,
          allowedForUnauthorizedUsers: true,
        },
      },
      {
        path: 'email-verification',
        component: SPCompanyEmailVerification,
        name: views.EMAIL_VERIFICATION_SP,
        meta: {
          fullScreen: true,
          allowedForUnauthorizedUsers: true,
        },
      },
      {
        path: 'finish',
        component: SPCompanyRegistrationFinished,
        name: views.SP_COMPANY_REGISTRATION_FINISHED,
        meta: {
          fullScreen: true,
          allowedForUnauthorizedUsers: true,
        },
      },
    ],
  },
];
